export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CursoAWS.vue?vue&type=template&id=59150116&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/CursoAWS.vue?vue&type=template&id=59150116&scoped=true
// module id = R9BF
// module chunks = 41